import { Box, Typography, useTheme } from "@mui/material";
import React, { memo, cloneElement } from "react";
interface InfoItemProps {
  label: string;
  value: string;
  icon: React.ReactElement;
  highlightColor?: string; // Optional color to apply to label, value, and icon
}
const WorkOrderCardBody: React.FC<InfoItemProps> = memo(
  ({ label, value, icon, highlightColor }) => {
    const theme = useTheme();
    
    // Clone icon with custom color if highlightColor is provided
    const styledIcon = highlightColor
      ? cloneElement(icon, {
          sx: { ...icon.props.sx, color: highlightColor },
        })
      : icon;
    
    return (
      <Box 
        display="flex" 
        alignItems="center" 
        sx={{ 
          minWidth: 0,
          width: "100%",
          overflow: "hidden"
        }}
      >
        <Box sx={{ flexShrink: 0 }}>
          {styledIcon}
        </Box>
        <Box sx={{ minWidth: 0, flex: 1, overflow: "hidden" }}>
          <Typography
            variant="subtitle2"
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              color: highlightColor || "text.secondary",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {label}
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              color: highlightColor || theme.palette.text.primary,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {value}
          </Typography>
        </Box>
      </Box>
    );
  }
);
export default WorkOrderCardBody;
